import { RefreshCw, Plus, ArrowRight, X, ArrowLeft, FileArchive, Wallet } from 'lucide-react';

interface StyledButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  icon?: StyledButtonIcon;
  variant?: 'default' | 'dark';
}

export enum StyledButtonIcon {
  RefreshCw = 'RefreshCw',
  Plus = 'Plus',
  ArrowRight = 'ArrowRight',
  ArrowLeft = 'ArrowLeft',
  X = 'X',
  None = 'None',
  FileArchive = 'FileArchive',
  Wallet = 'Wallet',
}

const renderIcon = (icon: StyledButtonIcon) => {
  switch (icon) {
    case StyledButtonIcon.RefreshCw:
      return <RefreshCw className="w-4 h-4 mr-2" />;
    case StyledButtonIcon.Plus:
      return <Plus className="w-4 h-4 mr-2" />;
    case StyledButtonIcon.ArrowRight:
      return <ArrowRight className="w-4 h-4 mr-2" />;
    case StyledButtonIcon.ArrowLeft:
      return <ArrowLeft className="w-4 h-4 mr-2" />;
    case StyledButtonIcon.X:
      return <X className="w-4 h-4 mr-2" />;
    case StyledButtonIcon.FileArchive:
      return <FileArchive className="w-4 h-4 mr-2" />;
    case StyledButtonIcon.Wallet:
      return <Wallet className="w-4 h-4 mr-2" />;
    default:
      return null;
  }
};

export const StyledButton = ({
  text,
  onClick,
  disabled = false,
  icon = StyledButtonIcon.None,
  variant = 'default',
}: StyledButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        flex items-center px-4 py-2 rounded-lg transition-colors
        ${variant === 'dark'
          ? 'bg-black text-white hover:bg-gray-800'
          : 'bg-blue-500 text-white hover:bg-blue-600'
        }
        ${disabled
          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
          : 'bg-gradient-to-r from-blue-900/30 to-pink-100/20 text-white border border-gray-800 hover:bg-gray-800/50 hover:border-gray-700'
        }
      `}
    >
      {renderIcon(icon)}
      {text}
    </button>
  );
};
